import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { normalizeRoutePath } from '@/lib/utils';

const routePath = '/settings/integrations' as const;
export const Route = createFileRoute(routePath)({
  // The integrations grid is a tab of the Settings page, mounted from `?tab=`; a direct
  // hit on the bare path bounces there before this route loads. The route stays as the
  // layout parent for the per-integration drill-ins.
  beforeLoad: ({ location }) => {
    if (normalizeRoutePath(location.pathname) === normalizeRoutePath(routePath)) {
      throw redirect({ to: '/settings', search: { tab: 'integrations' } });
    }
  },
  component: IntegrationsLayout,
});

function IntegrationsLayout() {
  return <Outlet />;
}
